import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api, errMsg } from "@/lib/api";

const NONE = "__none";
const F = ({ label, children }) => <div className="space-y-1.5"><Label className="text-xs uppercase tracking-wider text-muted-foreground">{label}</Label>{children}</div>;

export const AddRequirementDialog = ({ open, woId, onClose, onDone }) => {
  const [types, setTypes] = useState([]);
  const [models, setModels] = useState([]);
  const [f, setF] = useState({ type_id: null, model_id: null, quantity: "", description: "" });
  useEffect(() => { if (open) { setF({ type_id: null, model_id: null, quantity: "", description: "" }); api.get("/catalog/types", { params: { active: true } }).then((r) => setTypes(r.data)); } }, [open]);
  useEffect(() => { if (f.type_id) api.get("/catalog/models", { params: { type_id: f.type_id, active: true } }).then((r) => setModels(r.data)); else setModels([]); }, [f.type_id]);
  const submit = async () => {
    try {
      const { data } = await api.post(`/work-orders/${woId}/preparation/lines`, { ...f, model_id: f.model_id || null, quantity: Number(f.quantity) });
      toast.success("Requerimiento agregado");
      onDone(data);
      onClose();
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-lg" data-testid="prep-add-dialog">
        <DialogHeader><DialogTitle className="font-display">Agregar requerimiento</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <F label="Tipo (catálogo)">
            <Select value={f.type_id || undefined} onValueChange={(v) => setF({ ...f, type_id: v, model_id: null })}>
              <SelectTrigger data-testid="prep-add-type-select"><SelectValue placeholder="Seleccionar tipo" /></SelectTrigger>
              <SelectContent>{types.map((t) => <SelectItem key={t.id} value={t.id}>{t.name}</SelectItem>)}</SelectContent>
            </Select>
          </F>
          <F label="Marca / modelo (opcional)">
            <Select value={f.model_id || NONE} onValueChange={(v) => setF({ ...f, model_id: v === NONE ? null : v })}>
              <SelectTrigger data-testid="prep-add-model-select"><SelectValue /></SelectTrigger>
              <SelectContent><SelectItem value={NONE}>Sin modelo especificado</SelectItem>{models.map((m) => <SelectItem key={m.id} value={m.id}>{m.brand} {m.model}</SelectItem>)}</SelectContent>
            </Select>
          </F>
          <F label="Cantidad requerida"><Input type="number" step="any" min="0" value={f.quantity} onChange={(e) => setF({ ...f, quantity: e.target.value })} data-testid="prep-add-qty" /></F>
          <F label="Descripción (opcional)"><Input value={f.description} onChange={(e) => setF({ ...f, description: e.target.value })} data-testid="prep-add-desc" /></F>
        </div>
        <DialogFooter><Button variant="ghost" onClick={onClose}>Cancelar</Button><Button onClick={submit} disabled={!f.type_id || !f.quantity} data-testid="prep-add-submit">Agregar</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
